<div class="tw-bg-white">
  <div class="tw-app-container tw-flex tw-justify-between tw-px-[16px] tw-py-[8px] tw-text-[#333333] tw-overflow-hidden">
    <div class="tw-flex-1 tw-h-[83px] tw-flex tw-items-center tw-gap-[50px] xs:tw-gap-2">
      <div navigateLink="/" class="tw-h-full tw-cursor-pointer tw-flex-shrink-0">
        <img
          class="tw-h-full tw-object-contain tw-select-none tw-pointer-events-none xs:tw-w-[60px]"
          src="/assets/images/logo_main.svg"
          alt="dealers stock"
        />
      </div>
      <app-search-input
        [control]="keywordControl"
        [searchProvider]="searchProvider"
        class="tw-flex-1 tw-max-w-[400px] gt-sm:tw-hidden tw-h-[36px]"
      />
    </div>
    <div class="tw-hidden gt-sm:tw-flex tw-gap-4">
      <app-button navigateLink="/managed-product" class="tw-my-auto">
        <div class="tw-flex tw-items-center tw-gap-2">
          <app-svg-icon src="/assets/icons/list.svg" class="tw-w-[1.25rem] tw-aspect-square" />
          <span class="tw-whitespace-nowrap">作品管理</span>
        </div>
      </app-button>
      <app-button navigateLink="/dashboard" class="tw-my-auto">
        <div class="tw-flex tw-items-center tw-gap-2">
          <app-svg-icon src="/assets/icons/circle-user-solid.svg" class="tw-h-[18px] tw-aspect-square" />
          <span class="tw-whitespace-nowrap">マイページ</span>
        </div>
      </app-button>
      <app-button navigateLink="/notification" class="tw-my-auto">
        <div class="tw-flex tw-items-center tw-gap-2">
          <app-svg-icon src="/assets/icons/bell-solid.svg" class="tw-h-[18px] tw-aspect-square" />
          <span class="tw-whitespace-nowrap">お知らせ</span>
        </div>
      </app-button>
      <div class="tw-flex tw-items-center">
        <a href="https://about.dealers-stock.jp" class="tw-h-fit" appFlatButton flatButtonStyle="border-secondary">
          <app-svg-icon src="/assets/icons/beginner.svg" class="tw-w-[1.25rem] tw-aspect-square" />
          <span>使い方ガイド</span>
        </a>
      </div>
    </div>
    <div class="tw-flex gt-sm:tw-hidden">
      <button type="button" class="" (click)="openMobileNav()" mat-ripple>
        <app-svg-icon src="/assets/icons/hamburger.svg" class="tw-w-[3rem] tw-my-auto tw-aspect-square" />
      </button>
    </div>
  </div>
</div>

<!-- モバイル用メニュー -->
<nav
  class="tw-absolute tw-top-0 tw-z-[1002] tw-w-full tw-translate-y-[-100%] tw-bg-[#101645] tw-py-[16px] tw-text-[16px] tw-text-white tw-opacity-0 tw-transition-transform xs:tw-block"
  [class.mobile-nav-opened]="this.isMobileNavigationOpened()"
>
  <div class="tw-absolute tw-right-[16px] tw-z-[1001]">
    <button type="button" class="tw-block tw-aspect-square tw-h-[42px] tw-p-[8px]" (click)="closeMobileNav()" mat-ripple>
      <app-svg-icon class="tw-text-white tw-aspect-square" src="/assets/images/cross.svg" />
    </button>
  </div>

  <ul class="tw-mb-[24px] tw-px-[16px]">
    <li>
      <button
        navigateLink="/"
        type="button"
        mat-ripple
        class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
        (click)="closeMobileNav()"
      >
        <app-svg-icon class="tw-h-5 tw-aspect-square" src="/assets/icons/board.svg" />
        <span>注文情報</span>
      </button>
    </li>
    <li>
      <button
        navigateLink="/managed-product"
        type="button"
        mat-ripple
        class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
        (click)="closeMobileNav()"
      >
        <app-svg-icon src="/assets/icons/list.svg" class="tw-h-5 tw-aspect-square" />
        <span>作品管理</span>
      </button>
    </li>
    <li>
      <button
        navigateLink="/dashboard"
        mat-ripple
        class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
        (click)="closeMobileNav()"
      >
        <app-svg-icon src="/assets/icons/circle-user-solid.svg" class="tw-h-5 tw-aspect-square" />
        <span>マイページ</span>
      </button>
    </li>
    <li>
      <button
        navigateLink="/notification"
        type="button"
        mat-ripple
        class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
        (click)="closeMobileNav()"
      >
        <app-svg-icon src="/assets/icons/bell-solid.svg" class="tw-h-5 tw-aspect-square" />
        <span>お知らせ</span>
      </button>
    </li>
    <li>
      <a
        href="https://about.dealers-stock.jp"
        type="button"
        mat-ripple
        class="tw-w-full tw-flex-wrap tw-py-[16px] tw-text-left tw-flex tw-items-center tw-gap-2"
      >
        <app-svg-icon class="tw-h-5 tw-text-white tw-aspect-square" src="/assets/icons/beginner.svg" />
        <span>使い方ガイド</span>
      </a>
    </li>
  </ul>
</nav>
